var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
import Typography from '../../Styles/Typography/Typography';
import Skeleton from '../../Progress/Skeleton/Skeleton';
const LabelStyle = styled.div `
  width: 100%;
  margin-bottom: ${props => (props.noMargin ? '0rem' : '0.4rem')};
`;
const Label = (_a) => {
    var { isDisabled = false, color = 'main', label = 'Label', labelSize = 'article', noMargin = false, isLoading = false, skeleton, mediaQuery } = _a, props = __rest(_a, ["isDisabled", "color", "label", "labelSize", "noMargin", "isLoading", "skeleton", "mediaQuery"]);
    const theme = useTheme();
    return (label
        ? (isLoading
            ? _jsx(Skeleton, Object.assign({ height: labelSize }, skeleton))
            : _jsx(LabelStyle, Object.assign({ noMargin: noMargin }, props, { children: _jsx(Typography, Object.assign({ size: labelSize, color: isDisabled ? theme.utils.getColor('dark') : color, mediaQuery: mediaQuery }, { children: label })) })))
        : _jsx(_Fragment, {}));
};
export default Label;
